import { ShieldCheck, SignIn, Sparkle } from "@phosphor-icons/react";
import { useState } from "react";
import { useStaffOrders } from "../../context/StaffOrdersContext";

export function StaffAuthScreen() {
  const { login, isLoading } = useStaffOrders();
  const [form, setForm] = useState({
    login: "",
    password: ""
  });
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState<{ tone: "idle" | "error"; text: string }>({
    tone: "idle",
    text: ""
  });

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitting(true);
    setStatus({
      tone: "idle",
      text: "Подключаем смену и подгружаем очередь."
    });

    try {
      await login(form);
    } catch (error) {
      setStatus({
        tone: "error",
        text: error instanceof Error ? error.message : "Не удалось войти в панель сотрудников."
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="relative flex flex-1 items-center px-4 pb-8 pt-6">
      <div className="w-full space-y-5">
        <div>
          <p className="text-[0.72rem] uppercase tracking-[0.22em] text-amber-200/70">Панель сотрудников</p>
          <h1 className="mt-3 text-[2rem] font-semibold leading-[0.94] tracking-[-0.07em] text-stone-50">
            Вход в рабочую смену
          </h1>
          <p className="mt-3 max-w-[30ch] text-sm leading-6 text-stone-400">
            Очередь заказов, кухня, сборка и статусы подтягиваются после авторизации сотрудника.
          </p>
        </div>

        <article className="rounded-[2.2rem] bg-[linear-gradient(160deg,#f2ede4_0%,#dbcfbb_100%)] p-5 text-stone-950 shadow-[0_28px_64px_-40px_rgba(0,0,0,0.72)]">
          <p className="inline-flex items-center gap-2 rounded-full border border-stone-900/8 bg-white/70 px-3 py-1.5 text-[0.7rem] uppercase tracking-[0.18em] text-stone-700">
            <Sparkle size={14} weight="fill" />
            dispatch access
          </p>
          <h2 className="mt-4 text-[1.5rem] font-semibold leading-[0.98] tracking-[-0.05em]">
            Подключение к live-очереди
          </h2>
          <p className="mt-2 text-sm leading-6 text-stone-700">
            После входа откроются новые заказы, движение кухни и статусы выдачи.
          </p>

          <form onSubmit={handleSubmit} className="mt-5 grid gap-4">
            <label className="grid gap-2 text-sm text-stone-700">
              E-mail или логин
              <input
                value={form.login}
                onChange={(event) => setForm((current) => ({ ...current, login: event.target.value }))}
                placeholder="worker@mail.ru"
                className="rounded-[1.25rem] border border-stone-900/10 bg-white/84 px-4 py-3 text-base text-stone-950 outline-none transition duration-300 placeholder:text-stone-400 focus:border-stone-950/30"
              />
            </label>

            <label className="grid gap-2 text-sm text-stone-700">
              Пароль
              <input
                type="password"
                value={form.password}
                onChange={(event) => setForm((current) => ({ ...current, password: event.target.value }))}
                placeholder="Введите пароль"
                className="rounded-[1.25rem] border border-stone-900/10 bg-white/84 px-4 py-3 text-base text-stone-950 outline-none transition duration-300 placeholder:text-stone-400 focus:border-stone-950/30"
              />
            </label>

            <div
              className={[
                "min-h-6 text-sm leading-7",
                status.tone === "error" ? "text-rose-700" : "text-stone-600"
              ].join(" ")}
            >
              {status.text}
            </div>

            <button
              type="submit"
              disabled={submitting || isLoading}
              className="inline-flex items-center justify-center gap-2 rounded-[1.4rem] bg-stone-950 px-4 py-3 text-sm font-medium text-stone-50 transition duration-300 disabled:opacity-70 active:translate-y-px active:scale-[0.98]"
            >
              <SignIn size={16} />
              {submitting ? "Подключаем..." : "Войти в смену"}
            </button>
          </form>
        </article>

        <div className="rounded-[1.9rem] border border-white/8 bg-white/5 p-4 text-sm leading-6 text-stone-300">
          <p className="inline-flex items-center gap-2 font-medium text-stone-100">
            <ShieldCheck size={16} className="text-amber-200" />
            Доступ получают только сотрудники смены.
          </p>
          <p className="mt-2">
            После входа панель будет работать с серверной базой заказов и общими статусами, а не с локальным браузерным кэшем.
          </p>
        </div>
      </div>
    </main>
  );
}
